import { PipesModule } from '@digipay/ng-lib-pipes';

import { IWallet } from '../../models/wallet.interface';
import { IBar } from '../../../../data-access/models/assets-bar.interface';
import { BorderColorsEnum, NgxDividerComponent } from '@digipay/ngx-divider';
import { AssetsBarComponent } from '../../../../shared/components/assets-bar/assets-bar.component';
import { ChangeDetectionStrategy, Component, input, OnChanges, signal, SimpleChanges } from '@angular/core';

@Component({
  selector: 'wealth-applet-inventory-availible',
  standalone: true,
  imports: [PipesModule, NgxDividerComponent, AssetsBarComponent],
  templateUrl: './inventory-availible.component.html',
  styleUrl: './inventory-availible.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryAvailibleComponent implements OnChanges {
  wallet = input.required<IWallet>();
  barConfig = signal<IBar[] | undefined>(undefined);

  protected readonly BorderColorsEnum = BorderColorsEnum;

  ngOnChanges(changes: SimpleChanges): void {
    const total = this.wallet()?.uncollectibleBalance + this.wallet()?.withdrawalBalance;
    if (changes['wallet']) {
      this.barConfig.set([
        {
          color: '#1159FC',
          width: parseFloat(((this.wallet().withdrawalBalance / total) * 100).toFixed(1)),
        },
        {
          color: '#FEC003',
          width: parseFloat(((this.wallet().uncollectibleBalance / total) * 100).toFixed(1)),
        },
      ]);
    }
  }
}
